module.exports = __webpack_public_path__ + "img/07_shimizu_19.12b65d76.jpg";